import { Pipe, PipeTransform } from '@angular/core';
import type { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';

@Pipe({
  name: 'withContentBleed',
  standalone: false
})
export class WithContentBleedPipe implements PipeTransform {
  transform(
    cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper | null,
    preview: boolean,
    multiplier: number = 1,
    addToFinalNumber: number = 0
  ): number {
    return cardsThatLayoutOntoPaper?.withContentBleed(preview, multiplier, addToFinalNumber) || 0;
  }
}
